import AuthProvider from './core/providers/AuthProvider';
import AppRouter from './core/router/AppRouter';

function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
